export const STATIC = 'STATIC'; // Local static
export const USER_CONTEXT_SPECIFIC_SUCCESS = 'USER_CONTEXT_SPECIFIC_SUCCESS'; // Successfully loaded Context Specific
export const USER_CONTEXT_SPECIFIC_FAIL = 'USER_CONTEXT_SPECIFIC_FAIL'; // Tried but failed to fetch context specific flags
